import { useSyncExternalStore } from 'react';

// True while the age gate or the alerts popup is pending/visible: other popups must wait.
let blocking = true;
const listeners = new Set();

export const setPriorityPopupBlocking = (value) => {
  if (blocking === value) return;
  blocking = value;
  listeners.forEach((l) => l());
};

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export const usePriorityPopupBlocking = () => useSyncExternalStore(subscribe, () => blocking);
